// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 35px;
  margin: 0;
  border-radius: 16px;
  background: #f6f1ef;
}
.container .cross-icon {
  z-index: 5;
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.container .cross-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.container .cross-icon:hover {
  background: #f2dbd9;
}

.title {
  font-family: AppFontMedium, sans-serif;
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.06em;
  text-align: center;
  color: var(--color-black);
  margin-bottom: 8px;
  text-transform: uppercase;
}

.info {
  font-family: AppFontLight;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.02em;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
}

.button {
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 25px;
}
.button:last-child {
  margin-bottom: 0;
}
.button_main {
  background: #ebdfda;
  font-family: AppFont, sans-serif;
  font-size: 15px;
  line-height: 25px;
  letter-spacing: 0.06em;
  text-align: center;
  color: var(--color-black);
  border-radius: 26px;
  text-transform: uppercase;
}
.button_main:hover {
  background: #f2dbd9;
}
.button_close {
  background: transparent;
  text-transform: uppercase;
  font-family: AppFont, sans-serif;
  font-size: 15px;
  line-height: 25px;
  letter-spacing: 0.06em;
  text-align: center;
  border-radius: 26px;
  color: var(--color-black);
}
.button_close:hover {
  background: #f2dbd9;
}`, "",{"version":3,"sources":["webpack://./src/app/components/info-modal/info-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AACF;AAAE;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAEF;AADE;EACC,WAAA;EACA,YAAA;EACA,WAAA;AAGH;AADE;EACC,mBAAA;AAGH;;AAEA;EACE,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AACF;;AAEA;EACE,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,yBAAA;AAAF;;AAIA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AADF;AAGE;EACE,gBAAA;AADJ;AAIE;EACE,mBAAA;EACA,gCAAA;EAEA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;AAHJ;AAII;EACE,mBAAA;AAFN;AAOE;EACE,uBAAA;EACA,yBAAA;EAEA,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,yBAAA;AAPJ;AASI;EACE,mBAAA;AAPN","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 35px;\n  margin: 0;\n  border-radius: 16px;\n  background: #f6f1ef;\n  .cross-icon {\n\t\tz-index: 5;\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\tmargin: 0px;\n\t\tbackground: var(--color-white-accent);\n\t\twidth: 35px;\n\t\theight: 35px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmargin: 0px;\n\t\t}\n\t\t&:hover {\n\t\t\tbackground: #f2dbd9;\n\t\t}\n\t}\n}\n\n.title {\n  font-family: AppFontMedium, sans-serif;\n  font-size: 20px;\n  line-height: 23px;\n  letter-spacing: 0.06em;\n  text-align: center;\n  color: var(--color-black);\n  margin-bottom: 8px;\n  text-transform: uppercase;\n}\n\n.info {\n  font-family: AppFontLight;\n  font-size: 14px;\n  line-height: 16px;\n  letter-spacing: 0.02em;\n  text-align: center;\n  color: var(--color-black);\n\n  text-transform: uppercase;\n\n}\n\n.button {\n  height: 40px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n  margin-top: 25px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  &_main {\n    background: #ebdfda;\n    font-family: AppFont, sans-serif;\n\n    font-size: 15px;\n    line-height: 25px;\n    letter-spacing: 0.06em;\n    text-align: center;\n    color: var(--color-black);\n    border-radius: 26px;\n    text-transform: uppercase;\n    &:hover {\n      background: #f2dbd9;\n\n    }\n  }\n\n  &_close {\n    background: transparent;\n    text-transform: uppercase;\n\n    font-family: AppFont, sans-serif;\n    font-size: 15px;\n    line-height: 25px;\n    letter-spacing: 0.06em;\n    text-align: center;\n\n    border-radius: 26px;\n    color: var(--color-black);\n\n    &:hover {\n      background: #f2dbd9;\n\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
